import React, { useState, useCallback } from 'react';
import { GuideNotes, NeuroMessage } from '@ignitesales/neuro-application';
import { Modal } from '@ignitesales/neuro-application/src/neuro-ui';

const NotesComponent = () => {
    const [showNotesModal, setShowNotesModal] = useState(false);

    const handleOpenNotesModal = useCallback(() => {
        setShowNotesModal(true);
    }, []);

    const notesModal = (
        <Modal
            show={showNotesModal}
            onClose={() => setShowNotesModal(false)}
            className="modal--notes"
            title={<NeuroMessage id="notes.title" />}
            nodeId="root"
            closeBtn={<i className="ion-md-close" />}
        >
            <div className="notes-container">
                <GuideNotes charactersRemaining={255} />
                <div className="notes-disclaimer-footer">
                    <small className="text-muted font-italic">
                        <NeuroMessage id="notes.disclaimer" />                        
                    </small>
                </div>
            </div>
        </Modal>
    );

    return (
        <>
            {notesModal}
            <ul className="branchMenu__options">
                <li>
                    <a onClick={handleOpenNotesModal}>
                        <i className="ion-md-create" />
                        <NeuroMessage id="header.menu.notes"/>
                    </a>
                </li>
            </ul>
        </>
    );
};

export default NotesComponent; 